<template>
  <div class="about-section">
    <img src="@/assets/logo/long-logo.png">

    <div class="words-section">
      <div class="text-xs-center about-info">
        <p>Developed by Eliud Arudo of Soderiel Consultants. Please click the link below to check out more of our apps.</p>

        <br>

        <!-- <button
          ion-button
          clear
          large
          class="no-transform green-clear-button"
          color="primary"
        >Contact Us</button>-->
        <v-btn clear flat round color="primary" @click="openLink()">Contact us</v-btn>
        <br>
        <br>

        <span class="copyright">&copy; 2019</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class AboutPage extends Vue {
  openLink() {
    // Open another tab
    const win = window.open("https://web.facebook.com/soderielapps/", "_blank");
    win.focus();
  }
}
</script>

<style lang="scss">
$primary: #95ff00;

.about-section {
  position: relative;

  img {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 10%;
  }

  .words-section {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .about-info {
      width: 300px;

      p {
        font-weight: 200;
        font-size: 1.1em;
      }

      span {
        font-size: 0.9em;
      }
    }
  }
}
</style>
